import { isNoEmptyString } from 'Lib/is-no-empty-string/is-no-empty-string';
import { isIe } from 'Lib/is-ie/is-ie';

const elsLinkToReader = document.querySelectorAll('.book-page__link-to-reader');
const elReaderSeparatePage = document.querySelector('.book-page__reader-separate-page');

function onLinkToReaderClick(item, index, separatePage = false) {
    const elLink = item;
    const src = elLink?.getAttribute('data-pdf');
    const srcValue = isNoEmptyString(src) ? src : null;

    if (isIe()) {
        if (srcValue) {
            window.open(srcValue, '_blank');
        }
    } else {
        Promise.all([
            import('react'),
            import('react-dom'),
            import('Bem/site/reader/react/components/ReactReader.jsx'),
            import('Lib/w/w'),
            import('Lib/bp/bp'),
        ])
            .then(([
                { default: React },
                { default: ReactDOM },
                { ReactReader },
                { getW },
                { eksmoBP },
            ]) => {
                const nomcode = elLink?.getAttribute('data-nomcode');
                const ageLimit = elLink?.getAttribute('data-age-limit');
                const link = elLink?.getAttribute('data-link');
                const linkOnlyReader = elLink?.getAttribute('data-link-only-reader');
                const image = elLink?.getAttribute('data-image');
                const title = elLink?.getAttribute('data-title');
                // Book24 button data-attributes // Скрываем до появления новой ЧГ корзины
                // const book24Id = elLink?.getAttribute('data-book24-id');
                // const book24Price = elLink?.getAttribute('data-book24-price');
                const linkShop = elLink?.getAttribute('data-link-shop');
                // Ebook button data-attributes
                const ebookLink = elLink?.getAttribute('data-ebook-link');
                const ebookShop = elLink?.getAttribute('data-ebook-shop');
                const ebookPrice = elLink?.getAttribute('data-ebook-price');
                // Preorder button data-attributes // Скрываем до появления новой ЧГ корзины
                // const preorder = elLink?.getAttribute('data-book24-widget-product-type');
                const preorder = elLink?.getAttribute('data-preorder');

                if (!separatePage) {
                    // Рендер необходимой верстки
                    document.body.insertAdjacentHTML('beforeend', `<div id="js-react-reader${index}"></div>`);
                }

                ReactDOM.render(
                    <ReactReader
                        nomcode={isNoEmptyString(nomcode) ? nomcode : null}
                        src={srcValue}
                        isMobile={getW() < eksmoBP.mdMin}
                        ageLimit={typeof ageLimit === 'string' ? parseInt(ageLimit) || 0 : 0}
                        elForClickOutsideToShow={elLink}
                        link={link}
                        linkOnlyReader={linkOnlyReader}
                        image={image}
                        title={title}
                        linkShop={linkShop}
                        // book24={{
                        //     id: isNoEmptyString(book24Id) ? book24Id : null,
                        //     price: isNoEmptyString(book24Price) ? book24Price : null,
                        // }}
                        ebook={{
                            link: isNoEmptyString(ebookLink) ? ebookLink : null,
                            shop: isNoEmptyString(ebookShop) ? ebookShop : null,
                            price: isNoEmptyString(ebookPrice) ? ebookPrice : null,
                        }}
                        preorder={preorder}
                        separatePage={separatePage}
                    />,
                    document.getElementById(`${separatePage ? 'reader-separate-page' : `js-react-reader${index}`}`),
                );
            });
    }
}

elsLinkToReader.forEach((item, i) => {
    item?.addEventListener('click', () => {
        onLinkToReaderClick(item, i);
    }, { once: true });
});

if (elReaderSeparatePage) {
    onLinkToReaderClick(elReaderSeparatePage, 1, true);
}
